export default __webpack_public_path__ + "static/flop-pm-5b8e05df94f63853a5fef972316d63d1.png";